/** Dependency-first strongly connected components, using iterative walks for large graphs. */
export function scopeGraphComponents(dependencies: Map<string, string[]>): string[][] {
	const visited = new Set<string>();
	const finished: string[] = [];
	for (const id of Array.from(dependencies.keys())) {
		if (visited.has(id)) continue;
		visited.add(id);
		const stack = [{ id, index: 0 }];
		while (stack.length) {
			const frame = stack[stack.length - 1];
			const neighbors = dependencies.get(frame.id) ?? [];
			if (frame.index === neighbors.length) { finished.push(frame.id); stack.pop(); continue; }
			const next = neighbors[frame.index++];
			if (!visited.has(next)) { visited.add(next); stack.push({ id: next, index: 0 }); }
		}
	}
	const reverse = new Map<string, string[]>();
	for (const [id, values] of Array.from(dependencies)) {
		for (const dependency of values) {
			const dependents = reverse.get(dependency) ?? [];
			dependents.push(id); reverse.set(dependency, dependents);
		}
	}
	visited.clear();
	const components: string[][] = [];
	for (const id of finished.reverse()) {
		if (visited.has(id)) continue;
		const component: string[] = [];
		const pending = [id]; visited.add(id);
		while (pending.length) {
			const next = pending.pop()!; component.push(next);
			for (const dependent of reverse.get(next) ?? []) {
				if (!visited.has(dependent)) { visited.add(dependent); pending.push(dependent); }
			}
		}
		components.push(component.sort());
	}
	return components.reverse();
}
